module.exports = __webpack_public_path__ + "media/images/icons/icn_029-f6f6199e66e803e03daf44eb62a93f1f.svg";